import { useContext } from 'react';
import { LinkUserMaterial } from '../../../../../api/user-material';
import parseYoutubeURL from '../../../../../utils/parseYoutubeURL';
import { UserMaterialDialogHeaderTags } from '../../../components/UserMaterialDialogHeaderTags';
import EmbeddableMediaModal from '../../components/modals/EmbeddableMediaModal';
import { NodeWithoutDescription } from '../../../../../api/table-of-content';
import IdentityContext from '../../../../../contexts/IdentityContext';
import ModuleContext from '../../../_contexts/ModuleContext';

export default function useLinkUserMaterial() {
  const { identity } = useContext(IdentityContext);
  const { module, subModules } = useContext(ModuleContext);

  function openLinkUserMaterial(material: LinkUserMaterial, nodes: NodeWithoutDescription[]) {
    if (!module) throw new Error('Module context not found');

    const moduleForMaterial = [module, ...subModules].find(m => m.id === material.moduleId);

    if (!moduleForMaterial) throw new Error('Module for material not found');

    const parsedYoutubeURL = parseYoutubeURL(material.href);

    if (parsedYoutubeURL) {
      return (
        <EmbeddableMediaModal
          url={parsedYoutubeURL}
          name={material.name}
          id="embeddable-media-modal"
          headerProps={{
            title: material.name,
            titleTooltip: material.name,
            tags: (
              <UserMaterialDialogHeaderTags
                material={material}
                nodes={nodes}
                isTeacherAlike={identity.isTeacherAlike}
                module={moduleForMaterial}
              />
            ),
          }}
        />
      );
    }
  }

  return {
    openLinkUserMaterial,
  };
}
